
class CollapsibleTabs extends HTMLElement {
    constructor() {
      super();

       this.selectors = {
        trigger: '.collapsible-trigger',
        module: '.collapsible-content',
        moduleInner: '.collapsible-content__inner',
        tabs: '.collapsible-trigger--tab'
      };

       this.classes = {
        hide: 'hide',
        open: 'is-open',
        autoHeight: 'collapsible--auto-height',
        tabs: 'collapsible-trigger--tab'
      };

      this.isTransitioning = false;

      this.querySelectorAll(this.selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(this.classes.open);
        trigger.setAttribute('aria-expanded', state);
        trigger.removeEventListener('click', ()=>{});
        trigger.addEventListener('click', this.toggle.bind(this));
      });

      // fix height transition issue
      var this_tabs = this;
      // window.addEventListener('resize', function(){
      //   if(screen.width > 750){
      //     this_tabs.querySelectorAll(this_tabs.selectors.module).forEach(tab => {
      //       tab.style.height = 'unset';
      //     })
      //   }else{
      //     if(!this_tabs.isTransitioning){
      //       this_tabs.querySelectorAll(this_tabs.selectors.module).forEach(tab => {
      //         tab.style.height = '0';
      //       })
      //     }
      //   }
      // });
    }


     toggle(evt) {
        if (this.isTransitioning) {
          return;
        }

        this.isTransitioning = true;

        var el = evt.currentTarget;
        var isOpen = el.classList.contains(this.classes.open);
        var isTab = el.classList.contains(this.classes.tabs);
        var moduleId = el.getAttribute('aria-controls');
        var container = document.getElementById(moduleId);

        if (!moduleId) {
          moduleId = el.dataset.controls;
        }

        // No ID, bail
        if (!moduleId) {
          return;
        }

        // If container=null, there isn't a matching ID.
        // Check if data-id is set instead. Could be multiple.
        // Select based on being in the same parent div.
        if (!container) {
          var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
          if (multipleMatches.length > 0) {
            container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
          }
        }

        if (!container) {
          this.isTransitioning = false;
          return;
        }

        var height = container.querySelector(this.selectors.moduleInner).offsetHeight;
        var isAutoHeight = container.classList.contains(this.classes.autoHeight);
        var parentCollapsibleEl = container.parentNode.closest(this.selectors.module);
        var childHeight = height;

        if (isTab) {
          if(isOpen) {
            this.isTransitioning = false;
            return;
          }

          var newModule;
          document.querySelectorAll(this.selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
            el.classList.remove(this.classes.open);
            newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
            this.setTransitionHeight(newModule, 0, true);
          });
        }

        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            this.setTransitionHeight(container, height, isOpen, isAutoHeight);
          }, 0);
        }

        if (isOpen && !isAutoHeight) {
          height = 0;
        }

        el.setAttribute('aria-expanded', !isOpen);
        if (isOpen) {
          el.classList.remove(this.classes.open);
        } else {
          el.classList.add(this.classes.open);
        }

        this.setTransitionHeight(container, height, isOpen, isAutoHeight);

        // If we are in a nested collapsible element like the mobile nav,
        // also set the parent element's height
        if (parentCollapsibleEl) {
          var totalHeight = isOpen
                            ? parentCollapsibleEl.offsetHeight - childHeight
                            : height + parentCollapsibleEl.offsetHeight;

          this.setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
        }

      }

     setTransitionHeight(container, height, isOpen, isAutoHeight) {
        container.classList.remove(this.classes.hide);
        var this_temp = this;
        this.prepareTransition(container, function() {
          container.style.height = height+'px';
          if (isOpen) {
            container.classList.remove(this_temp.classes.open);
          } else {
            container.classList.add(this_temp.classes.open);
          }
        });

        if (!isOpen && isAutoHeight) {
          var o = container;
          window.setTimeout(function() {
            o.style.height = 'auto';
            this.isTransitioning = false;
          }, 500);
        } else {
          this.isTransitioning = false;
        }
      }

      prepareTransition(el, callback) {
        el.addEventListener('transitionend', removeClass);

        function removeClass(evt) {
          el.classList.remove('is-transitioning');
          el.removeEventListener('transitionend', removeClass);
        }

        el.classList.add('is-transitioning');
        el.offsetWidth; // check offsetWidth to force the style rendering

        if (typeof callback === 'function') {
          callback();
        }
      }

  }

customElements.define('collapsible-tabs', CollapsibleTabs)